import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { UserProvider } from "./contexts/userContext";
import './styles/app.css';
import SalesAll from "./pages/SalesAll.jsx";
import Login from "./pages/Login.js";
import PrivateRoute from "./pages/PrivateRoute";
import Station from "./pages/Station.jsx";
import Raports from "./pages/Raports.jsx";
import Supplies from "./pages/Supplies.jsx";
import Performance from "./pages/Performance.jsx";
import TankTemperatures from "./pages/TanksTemperatures.jsx";
import Settings from "./pages/Settings.jsx";

function App() {
  return (
    <BrowserRouter>
      <UserProvider>
        <Routes>
          <Route exact path="/login" element={<Login/>}/>
          <Route element={<PrivateRoute/>}>
            <Route exact path="/" element={<Navigate to={localStorage.getItem("role") === "driver" ? "/supplies" : "/sales"} replace />} />
            <Route exact path="/sales" element={<SalesAll/>} />
            <Route exact path="/raports" element={<Raports/>} />
            <Route exact path="/supplies" element={<Supplies/>} />
            <Route exact path="/tanks-temperatures" element={<TankTemperatures/>} />
            <Route exact path={`/station`} element={<Station/>} />
            <Route exact path='/performance' element={<Performance/>} />
            <Route exact path='/settings' element={<Settings/>} />
          </Route>
        </Routes>
      </UserProvider>
    </BrowserRouter>
  );
}
 
export default App;